export default __webpack_public_path__ + "static/media/cely.6fb1502d.webp";